if (!customElements.get('dm-bundle')) {
 customElements.define('dm-bundle', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   this.addEventListener('change', () => this.sync(), {signal:this.abort.signal});
   this.sync();
   if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
    if (String(event.data.sectionId) === this.dataset.section) this.updatePrice(event.data.variant);
   });
  }
  disconnectedCallback() { this.abort?.abort(); this.unsubscribe?.(); }
  sync() {
   const selected = this.querySelector('input[type=radio]:checked');
   this.querySelector('input[name=quantity]').value = selected.value;
   const form = document.getElementById(this.dataset.form);
   if(form) form.dataset.dmDiscount = selected.dataset.code || '';
  }
  updatePrice(variant) {
   if(!variant) return;
   const money = cents => new Intl.NumberFormat('sr-RS', {style:'currency',currency:this.dataset.currency || 'RSD'}).format(cents/100);
   this.querySelectorAll('.dm-package').forEach(row => {
    const radio=row.querySelector('input'); const total=variant.price * Number(radio.dataset.paid);
    row.querySelector('[data-total]').textContent=money(total);
    row.querySelector('[data-unit]').textContent=money(total/Number(radio.value));
    const original=row.querySelector('[data-original]');
    if(original) {
     const compareAt=Number(variant.compare_at_price);
     const showCompare=Number.isFinite(compareAt) && compareAt>Number(variant.price);
     original.hidden=!showCompare;
     original.textContent=showCompare ? money(compareAt * Number(radio.value)) : '';
    }
   });
   this.sync();
  }
 });
}
